<div class="container-fluid" [ngClass]="{'py-3': !noPaddingWrap}">
    <div *ngIf="config.rows.length > 0" class="settings-toggle-wrapper dropdown">
        <button
                *ngIf="!config.disableColumnsOptions"

                (click)="toggleSettings()"

                type="button"
                class="btn btn-settings"
        >
            <i class="fa fa-cog"></i>
        </button>

        <div
                *ngIf="!config.disableColumnsOptions"

                [ngStyle]="{'display': !isSettingsShown ? 'none' : 'block'}"

                class="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
        >
            <h6 class="dropdown-header text-primary">Display columns</h6>

            <div class="form-check d-flex flex-column">
                <app-checkbox
                        *ngFor="let checkbox of settingsCheckboxes"

                        [disabled]="checkbox.disabled"
                        [(ngModel)]="checkbox.value"

                        (ngModelChange)="toggleColumn(checkbox.name, $event)"
                >
                    <ng-container text> {{ checkbox.placeholder }} </ng-container>
                </app-checkbox>
            </div>

            <hr class="mt-0">

            <div class="text-center">
                <button (click)="resetColumnState()" type="button" class="btn btn-outline-accent mr-2"> Reset</button>
                <button (click)="isSettingsShown = false" type="button" class="btn btn-outline-primary"> Close</button>
            </div>
        </div>
    </div>
    <div class="table-responsive">
        <table [ngClass]="{'no-wrapped-text': noWrapText}" class="table table-hover table-striped">
            <thead>
            <ng-container *ngIf="!hasGrouped; else groupedTemplate">
                <tr class="header-row">
                    <th
                            *ngIf="config.hasToggleableOrCheckableRows && (config.rows.length > 0)"
                            [colSpan]="toggleableRowColSpan" class="text-right"
                    >
                <app-checkbox *ngIf="config.hasHeaderCheckbox" [(ngModel)]="config.headerChecked"  (ngModelChange)="onHeaderChecked($event)"></app-checkbox>
            </th>

                    <ng-container *ngFor="let checkbox of settingsCheckboxes">
                        <th
                                *ngIf="checkbox.value"

                                [ngClass]="{'text-right': checkbox.shifted}"
                                [colSpan]="checkbox.colspan"
                        >
                            {{ checkbox.placeholder }}
                            <a
                                *ngIf="checkbox.sortable"
                                (click)="onSortClick(checkbox.name)"
                                [ngClass]="{'sorted-column': sortedColumn.selector === checkbox.name && sortedColumn.ascending}"
                                href="javascript:void('0');"
                            >
                                <i [ngClass]="{
                                    'text-danger': sortedColumn.selector === checkbox.name,
                                    'text-body': sortedColumn.selector !== checkbox.name
                                }"
                                    class="fa fa-caret-down"
                                ></i>
                            </a>
                        </th>
                    </ng-container>

                    <th *ngIf="config.actionMenu && (config.rows.length > 0)">Actions</th>

                    <th scope="col" *ngIf="config.checkboxActionMenu && (config.rows.length > 0)">{{config.checkboxActionMenuTitle}}</th>

                    <th *ngIf="(config.rows.length > 0) && !config.disableColumnsOptions" class="filter-cell-width"></th>
                </tr>
            </ng-container>

            <ng-template #groupedTemplate>
                <tr>
                    <th
                            *ngIf="config.hasToggleableOrCheckableRows && (config.rows.length > 0)"
                            [rowSpan]="2"
                            [colSpan]="toggleableRowColSpan"
                    ></th>

                    <ng-container *ngFor="let column of config.columns; let childColumnIndex = index">
                        <th
                                *ngIf="config.hiddenColumnIds.indexOf(column.selector) < 0"

                                [colSpan]="column.colspan"

                                [rowSpan]="!column.childColumns ? 2 : 1"

                                [ngClass]="{
                                'align-bottom': !column.childColumns,
                                'border-bottom-0': column.childColumns,
                                'text-center': column.childColumns,
                                'text-right': column.shifted,
                                'borderLeft borderRight': column.childColumns && (column.childColumns.length > 0)
                            }"
                        >
                            {{ column.label }}
                        </th>
                    </ng-container>

                    <th *ngIf="config.actionMenu && (config.rows.length > 0)"></th>

                    <th scope="col" *ngIf="config.checkboxActionMenu && (config.rows.length > 0)"></th>

                    <th *ngIf="(config.rows.length > 0) && !config.disableColumnsOptions"></th>
                </tr>
                <tr class="sub-head-row">
                    <ng-container *ngFor="let column of config.columns">
                        <ng-container *ngIf="column.childColumns && (column.childColumns.length > 0)">
                            <ng-container *ngFor="let childColumn of column.childColumns; let childColumnIndex = index">
                                <th
                                        *ngIf="config.hiddenColumnIds.indexOf(column.selector) < 0"

                                        [colSpan]="childColumn.colspan"

                                        [ngClass]="{
                                        'borderLeft': childColumnIndex === 0,
                                        'text-right': childColumn.shifted,
                                        'borderRight': childColumnIndex === (column.childColumns.length - 1)
                                    }"
                                >
                                    {{ childColumn.label }}
                                </th>
                            </ng-container>
                        </ng-container>
                    </ng-container>

                    <th *ngIf="config.actionMenu && (config.rows.length > 0)">Actions</th>

                    <th scope="col" *ngIf="config.checkboxActionMenu && (config.rows.length > 0)">{{config.checkboxActionMenuTitle}}</th>

                    <th *ngIf="(config.rows.length > 0) && !config.disableColumnsOptions"></th>
                </tr>
            </ng-template>
            </thead>
            <tbody>
            <ng-container *ngIf="config.rows.length > 0; else notFound">
                <ng-container *ngIf="!config.form; else tableWithForm">
                    <ng-container *ngFor="let row of config.rows">
                        <tr
                                (click)="onRowClicked(row)"

                                *ngIf="!row.hidden"

                                [ngClass]="{
                                'main-row': row.isMainRow,
                                'sub-row': !row.isMainRow && (row.subRowOf >= 0),
                                'collapsed': row.isMainRow && !row.toggled
                            }"
                        >
                            <td *ngIf="config.hasToggleableOrCheckableRows" [colSpan]="toggleableRowColSpan">
                                <div class="d-flex align-items-center justify-content-end"  (click)="onClickAllowPropagation($event, row.checkable)">
                                    <app-checkbox
                                            *ngIf="row.checkable"

                                            [(ngModel)]="row.checked"

                                            (ngModelChange)="onRowChecked(row)"
                                    ></app-checkbox>

                                    <i
                                            *ngIf="row.toggleable"
                                            class="fa fa-caret-right mr-1 ml-3 cursor-pointer"
                                    ></i>
                                </div>
                            </td>

                            <ng-container *ngFor="let data of row.dataItems">
                                <td
                                        *ngIf="!data.hidden"

                                        [ngClass]="{
                                            'text-right': data.shifted,
                                            'text-danger': data.hasNegativeValue
                                        }"

                                        [ngStyle]="{'padding-left': data.shifted && '25px'}"

                                        [colSpan]="!data.colspan ? 1 : data.colspan"

                                        (click)="onTableDataItemClick(row.rowId, data)"

                                        class="{{data?.class}}"
                                >
                                    <ng-container *ngIf="data.hasIcon && data.value">
                                        <ng-container *ngIf="!data.hasNegativeValue; else negativeIcon">
                                            <i *ngIf="data.value > 0" class="fa fa-caret-up text-success pl-1"></i>
                                        </ng-container>
                                        <ng-template #negativeIcon>
                                            <i class="fa fa-caret-down text-danger pl-1"></i>
                                        </ng-template>
                                    </ng-container>

                                    <span
                                        [class]="data.valueClass"
                                        [title]="data.title || ''"
                                    >{{ data.value }}</span>

                                    <button
                                        *ngIf="data.actionIconClass"
                                        type="button"
                                        class="btn btn-link report-table-cell-action"
                                        [title]="data.actionTitle || ''"
                                        (click)="onTableDataItemClick(row.rowId, data); $event.stopPropagation();"
                                    >
                                        <i class="fa" [ngClass]="data.actionIconClass"></i>
                                    </button>

                                    <ng-container *ngIf="data.hasInfoIcon && data.value">
                                        <em class="fa fa-info-circle text-primary d-inline-block align-middle ml-1"></em>
                                    </ng-container>
                                </td>
                            </ng-container>

                            <ng-container *ngIf="config.actionMenu && (config.rows.length > 0)">
                                <ng-container
                                    *ngTemplateOutlet="actionMenu; context: { rowId: row.rowId, disabledActions: row.disabledActions, hiddenActions: row.hiddenActions }"
                                ></ng-container>
                            </ng-container>

                            <ng-container *ngIf="config.checkboxActionMenu && (config.rows.length > 0)">
                                <div (click)="$event.stopPropagation();"
                                     class="d-inline btn btn-link mr-2 action-checkbox-container">
                                    <app-checkbox
                                        *ngIf="row.checkableActionMenu"
                                        [(ngModel)]="row.actionMenuChecked"
                                        [disabled]="row.actionMenuChecked"
                                        (click)="onCheckboxClicked(row);"
                                    ></app-checkbox>
                                </div>
                            </ng-container>

                            <td *ngIf="(config.rows.length > 0) && !config.disableColumnsOptions"></td>
                        </tr>
                    </ng-container>
                </ng-container>
                <ng-template #tableWithForm>
                    <ng-container *ngTemplateOutlet="formTable"></ng-container>
                </ng-template>
            </ng-container>
            <ng-template #notFound>
                <tr class="not-found">
                    <td [colSpan]="tableColumnsLength" class="text-center"> No results found.</td>
                </tr>
            </ng-template>
            </tbody>
            <tfoot>
            <ng-content select="[table-footer]"></ng-content>
            </tfoot>
        </table>
    </div>
</div>

<ng-template #formTable>
    <ng-container
            *ngIf="config.formSettings.arrayLength === config.rows.length"

            [formGroup]="config.formSettings.form"
    >
        <ng-container [formArrayName]="config.formSettings.arraySelector">
            <tr
                    *ngFor="let row of config.rows; let i = index"

                    (click)="onRowClicked(row)"

                    [formGroupName]="!config.formSettings.hasInlineFormIndex ? i : config.formSettings.inlineFormGroupIndex"
            >
                <ng-container *ngFor="let data of row.dataItems">
                    <td
                            *ngIf="!data.hidden && !data.shownControl"

                            [colSpan]="!data.colspan ? 1 : data.colspan"

                            (click)="onTableDataItemClick(data.value, data)"
                    >
                        <ng-container *ngIf="data.hasIcon && data.value">
                            <ng-container *ngIf="!data.hasNegativeValue; else negativeIcon">
                                <em *ngIf="data.value > 0" class="fa fa-caret-up text-success pl-1"></em>
                            </ng-container>
                            <ng-template #negativeIcon>
                                <em class="fa fa-caret-down text-danger pl-1"></em>
                            </ng-template>
                        </ng-container>

                        <span
                            [class]="data.valueClass"
                            [title]="data.title || ''"
                        >{{ data.value }}</span>

                        <button
                            *ngIf="data.actionIconClass"
                            type="button"
                            class="btn btn-link report-table-cell-action"
                            [title]="data.actionTitle || ''"
                            (click)="onTableDataItemClick(data.value, data); $event.stopPropagation();"
                        >
                            <i class="fa" [ngClass]="data.actionIconClass"></i>
                        </button>

                        <ng-container *ngIf="data.hasInfoIcon && data.value">
                            <em class="fa fa-info-circle text-primary d-inline-block align-middle ml-1"></em>
                        </ng-container>
                    </td>

                    <ng-container *ngIf="!data.hidden && data.shownControl && data.control">
                        <td [ngSwitch]="data.control.componentType">
                            <app-select
                                    *ngSwitchCase="componentTypes.Select"
                                    [formControlName]="data.control.name"
                                    [control]="data.control"
                            ></app-select>
                            <app-radio-group
                                    *ngSwitchCase="componentTypes.RadioGroup"
                                    [formControlName]="data.control.name"
                                    [control]="data.control"
                            ></app-radio-group>
                            <app-autocomplete
                                    *ngSwitchCase="componentTypes.Autocomplete"
                                    [formControlName]="data.control.name"
                                    [control]="data.control"
                            ></app-autocomplete>
                            <app-phone-autocomplete
                                    *ngSwitchCase="componentTypes.PhoneAutocomplete"
                                    [formControlName]="data.control.name"
                                    [control]="data.control"
                            ></app-phone-autocomplete>
                            <app-datepicker
                                    *ngSwitchCase="componentTypes.Datepicker"
                                    [formControlName]="data.control.name"
                                    [control]="data.control"
                            ></app-datepicker>
                            <app-country-autocomplete
                                    *ngSwitchCase="componentTypes.CountryAutocomplete"
                                    [formControlName]="data.control.name"
                                    [control]="data.control"
                            ></app-country-autocomplete>
                            <app-panel-input
                                    *ngSwitchDefault
                                    [formControlName]="data.control.name"
                                    [control]="data.control"
                            ></app-panel-input>
                        </td>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="config.actionMenu">
                    <td>
                        <ng-container
                                *ngTemplateOutlet="actionMenu; context: { rowId: row.rowId, disabledActions: row.disabledActions, hiddenActions: row.hiddenActions }"
                        ></ng-container>
                    </td>
                </ng-container>

                <ng-container *ngIf="config.checkboxActionMenu">
                    <td></td>
                </ng-container>

                <td *ngIf="(config.rows.length > 0) && !config.disableColumnsOptions"></td>
            </tr>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #actionMenu let-rowId="rowId" let-disabledActions="disabledActions" let-hiddenActions="hiddenActions">
    <ng-container *ngIf="config.actionMenuType !== actionMenuTypesEnum.Buttons; else buttonActions">
        <ng-container *ngFor="let menuItem of config.actionMenuItems">
            <a
                *ngIf="!hiddenActions || (hiddenActions && !hiddenActions[menuItem.action])"

                (click)="sendActionCode($event, menuItem.action, rowId, disabledActions && disabledActions[menuItem.action])"

                [ngClass]="{'disabled': disabledActions && disabledActions[menuItem.action]}"

                href="javascript:void(0);"
                class="d-inline btn btn-link mr-2"
            >{{ menuItem.linkText }}</a>
        </ng-container>
    </ng-container>
    <ng-template #buttonActions>
        <td>
            <ng-container *ngFor="let menuItem of config.actionMenuItems">
                <ng-container [ngSwitch]="menuItem.buttonType">
                    <button
                            *ngSwitchCase="buttonTypesEnum.Download"

                            (click)="sendActionCode($event, actionsEnum.Download, rowId, disabledActions && disabledActions[actionsEnum.Download])"

                            [disabled]="disabledActions && disabledActions[actionsEnum.Download]"

                            class="btn btn-icon text-muted mr-2"
                    ><i class="fa fa-download"></i></button>
                    <button
                            *ngSwitchCase="buttonTypesEnum.Preview"

                            (click)="sendActionCode($event, actionsEnum.Preview, rowId, disabledActions && disabledActions[actionsEnum.Preview])"

                            [disabled]="disabledActions && disabledActions[actionsEnum.Preview]"

                            class="btn btn-icon btn-accent mr-2"
                    ><i class="fa fa-eye"></i></button>
                    <button
                            *ngSwitchCase="buttonTypesEnum.Edit"

                            (click)="sendActionCode($event, actionsEnum.Edit, rowId, disabledActions && disabledActions[actionsEnum.Edit])"

                            [disabled]="disabledActions && disabledActions[actionsEnum.Edit]"

                            class="btn btn-icon btn-primary mr-2"
                    ><i class="fa fa-pencil"></i></button>
                    <button
                            *ngSwitchCase="buttonTypesEnum.Delete"

                            (click)="sendActionCode($event, actionsEnum.Delete, rowId, disabledActions && disabledActions[actionsEnum.Delete])"

                            [disabled]="disabledActions && disabledActions[actionsEnum.Delete]"

                            class="btn btn-icon btn-danger mr-2"
                    ><i class="fa fa-trash-o"></i></button>
                    <button
                            *ngSwitchCase="buttonTypesEnum.Approve"

                            (click)="sendActionCode($event, actionsEnum.Approve, rowId, disabledActions && disabledActions[actionsEnum.Approve])"

                            [disabled]="disabledActions && disabledActions[actionsEnum.Approve]"

                            class="btn btn-icon btn-accent mr-2"
                    ><i class="fa fa-check"></i></button>
                    <button
                            *ngSwitchCase="buttonTypesEnum.Decline"

                            (click)="sendActionCode($event, actionsEnum.Decline, rowId, disabledActions && disabledActions[actionsEnum.Decline])"

                            [disabled]="disabledActions && disabledActions[actionsEnum.Decline]"

                            class="btn btn-icon btn-danger mr-2"
                    ><i class="fa fa-times"></i></button>
                    <button
                            *ngSwitchCase="buttonTypesEnum.Copy"

                            (click)="sendActionCode($event, actionsEnum.Copy, rowId, disabledActions && disabledActions[actionsEnum.Copy])"

                            [disabled]="disabledActions && disabledActions[actionsEnum.Copy]"

                            class="btn btn-icon btn-warning mr-2"
                    ><em class="fa fa-files-o"></em></button>
                    <button
                        *ngSwitchCase="buttonTypesEnum.Cancel"

                        (click)="sendActionCode($event, actionsEnum.Decline, rowId, disabledActions && disabledActions[actionsEnum.Decline])"

                        [disabled]="disabledActions && disabledActions[actionsEnum.Decline]"

                        class="d-inline-flex btn btn-outline-primary mr-2"
                    >Cancel</button>
                    <button
                        *ngSwitchCase="buttonTypesEnum.Save"

                        (click)="sendActionCode($event, actionsEnum.Save, rowId, disabledActions && disabledActions[actionsEnum.Save])"

                        [disabled]="disabledActions && disabledActions[actionsEnum.Save]"

                        [ngClass]="{
                            'btn-icon text-primary': !menuItem.linkText,
                            'btn-primary': menuItem.linkText
                        }"

                        class="d-inline-flex btn mr-2"
                    >
                        <ng-container *ngIf="menuItem.linkText; else saveTextContent">
                            {{ menuItem.linkText }}
                        </ng-container>
                        <ng-template #saveTextContent>
                            <em class="fa fa-save"></em>
                        </ng-template>
                    </button>
                    <button
                            *ngSwitchCase="buttonTypesEnum.Reset"

                            (click)="sendActionCode($event, actionsEnum.Reset, rowId, disabledActions && disabledActions[actionsEnum.Reset])"

                            [disabled]="disabledActions && disabledActions[actionsEnum.Reset]"

                            class="btn btn-primary"
                    >Reset
                    </button>
                </ng-container>
            </ng-container>
        </td>
    </ng-template>
</ng-template>
